import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from "@mui/material";
export const UiBadge = (props) => _jsx(Badge, Object.assign({}, props));
//# sourceMappingURL=ui_badge.js.map